__webpack_require__.p = "/bizx-smart-lite/mr-bike/";